export default "__VITE_ASSET__a9935894__"